// extracted by mini-css-extract-plugin
export default {"content":"App_content__h3Yev"};